import { render, staticRenderFns } from "./ReportLocking.vue?vue&type=template&id=6442737b&"
import script from "./ReportLocking.vue?vue&type=script&lang=js&"
export * from "./ReportLocking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports